<script>
  /**
   * Someone, as every screen shows them: their first name, with the handle beneath — "Raffi",
   * "@raffi" (wip-archive/social/SOCIAL_PHASE2_SHARING.md, Q5) — and an initial in place of a
   * photo. Never an address. What can be done about them sits at the end of the row, given by the
   * caller.
   */
  /**
   * @type {{
   *   person: { firstName: string, handle: string | null },
   *   note?: string,
   *   children?: import("svelte").Snippet,
   * }}
   */
  let { person, note = "", children } = $props();

  const initial = $derived((person.firstName || person.handle || "?").trim().charAt(0).toLocaleUpperCase());
</script>

<div class="flex min-h-14 items-center gap-3 py-2">
  <span
    class="bg-amber-soft text-amber-deep flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-semibold"
    aria-hidden="true">{initial}</span>
  <span class="min-w-0 flex-1">
    <span class="text-ink block truncate font-semibold">{person.firstName || `@${person.handle}`}</span>
    {#if person.handle || note}
      <span class="text-ink-muted block truncate text-sm">
        {person.handle ? `@${person.handle}` : ""}{person.handle && note ? " · " : ""}{note}
      </span>
    {/if}
  </span>
  {#if children}
    <span class="flex shrink-0 items-center gap-1">{@render children()}</span>
  {/if}
</div>
